import DataFetcherTemplate from "../hooks/fetchTemplate";

import BlockImageCabecera from "../components/BlockImageCabecera";
import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";
import Block3Columns from "../components/Block3Columns";
import Block4ColumnsText from "../components/Block4ColumnsText";
import Block2ColumnsText from "../components/Block2ColumnsText";
import Accordion from "../components/Accordion";
import BlockBackgroundImage from "../components/BlockBackgroundImage";
import BlockRightImage from "../components/BlockRightImage";
import BlockLeftImage from "../components/BlockLeftImage";
import FixedHeader from "../components/FixedHeader";

function CarismaIdente() {
  const DataDisplay = ({ data }) => (
    <>
      <>
        {data.map((item, index) => (
          <>
            <FixedHeader
              video={item.field_video_portada}
              span0={<> "Sentado</>}
              span1="en las diferentes"
              span3={<>cátedras del mundo"</>}
              span4="Fernando Rielo"
            ></FixedHeader>
            <div className="bluebg padding">
              <center>
                <div
                  className="layout6 fontsize14"
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque1,
                  }}
                />
              </center>
            </div>

            <div>
              <Breadcumbs
                content={
                  <>
                    <NavLink to="/servicios-juridicos">Carisma Idente</NavLink>
                  </>
                }
              ></Breadcumbs>
              <BlockLeftImage
                src={item.field_imagen2}
                content={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque2,
                      }}
                    />
                  </>
                }
              ></BlockLeftImage>
              <div>
                <div className="layout8">
                  <center>
                    <h2>
                      {" "}
                      Conoce los <b> servicios jurídicos </b>de la UTPL
                    </h2>
                  </center>
                </div>
                <Block2ColumnsText
                  col1={
                    <>
                      <p className="iconsize20">⚖️🤝</p>
                    </>
                  }
                  col2={
                    <>
                      <p className="iconsize20"> 🕊️🤝</p>

                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque10,
                        }}
                      />
                    </>
                  }
                ></Block2ColumnsText>
              </div>{" "}
              <div className="padding icon50 bluebg margin">
                <center>
                  <Block3Columns
                    col1={
                      <div>
                        {" "}
                        <img
                          src={item.field_imagen6}
                          alt="utpl consultorios"
                        ></img>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque6,
                          }}
                        />
                      </div>
                    }
                    col2={
                      <div>
                        <img
                          src={item.field_imagen7}
                          alt="utpl consultorios"
                        ></img>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque7,
                          }}
                        />
                      </div>
                    }
                    col3={
                      <div>
                        <img
                          src={item.field_imagen8}
                          alt="utpl consultorios"
                        ></img>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque8,
                          }}
                        />
                      </div>
                    }
                  ></Block3Columns>
                </center>
              </div>
              <div className="layout8 margin">
                <div
                  className="  width700"
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque1,
                  }}
                />
              </div>
            </div>
            <div className="padding icon100 ">
              <Block4ColumnsText
                col1={
                  <>
                    <img src={item.field_imagen2} alt="utpl consultorios"></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque2,
                      }}
                    />
                  </>
                }
                col2={
                  <>
                    {" "}
                    <img src={item.field_imagen3} alt="utpl consultorios"></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque3,
                      }}
                    />
                  </>
                }
                col3={
                  <>
                    {" "}
                    <img src={item.field_imagen4} alt="utpl consultorios"></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque4,
                      }}
                    />
                  </>
                }
                col4={
                  <>
                    {" "}
                    <img src={item.field_imagen5} alt="utpl consultorios"></img>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque5,
                      }}
                    />
                  </>
                }
              ></Block4ColumnsText>
            </div>
            <div className="graybg padding icon400">
              <BlockLeftImage
                src={item.field_imagen12}
                content={
                  <>
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque11,
                        }}
                      />
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque12,
                        }}
                      />

                      <Accordion
                        title="Familia"
                        content={
                          <>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.field_bloque13,
                              }}
                            />
                          </>
                        }
                      ></Accordion>
                      <Accordion
                        title="Laboral"
                        content={
                          <>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.field_bloque14,
                              }}
                            />
                          </>
                        }
                      ></Accordion>
                      <Accordion
                        title="Penal"
                        content={
                          <>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.field_bloque15,
                              }}
                            />
                          </>
                        }
                      ></Accordion>

                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque16,
                        }}
                      />
                    </div>
                  </>
                }
              >
                {" "}
              </BlockLeftImage>
            </div>

            <div className="graybg icon400">
              <BlockRightImage
                src={item.field_imagen17}
                content={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque17,
                      }}
                    />
                  </>
                }
              ></BlockRightImage>
            </div>

            <BlockBackgroundImage
              src={item.field_imagen18}
              content={
                <>
                  {" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque18,
                    }}
                  />
                </>
              }
            ></BlockBackgroundImage>
          </>
        ))}
      </>
    </>
  );
  return (
    <>
      {" "}
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/carisma-idente.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
    </>
  );
}

export default CarismaIdente;
